import { useTranslation } from 'react-i18next'
import { Card, CardContent, Badge } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'
import type { CategoryGroup } from './masterData.types'

export function CategoriesCard({ groups, total }: { groups: CategoryGroup[]; total: number }) {
  const { t } = useTranslation()
  return (
    <Card id={EID['masterdata-card-categories']}>
      <CardContent className="p-6">
        <h3 className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
          {t('productMasterData.cards.categories')}
          <Badge variant="secondary">{total}</Badge>
        </h3>
        <div className="space-y-3">
          {groups.map((g) => (
            <div key={g.root}>
              <p className="mb-1 text-xs uppercase tracking-wide text-neutral-400 dark:text-neutral-500">{g.root}</p>
              <div className="flex flex-wrap gap-1.5">
                {g.leaves.length === 0 ? (
                  <span className="text-sm text-neutral-400">—</span>
                ) : g.leaves.map((leaf) => (
                  <span key={leaf} className="rounded-md bg-neutral-100 px-2 py-0.5 text-xs text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300">{leaf}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
